/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description commentsAnswerAnwserIdCommentsByIdUsingGet参数
 * @property `answerId` 回答id
 * @property `lastCommentId` 上一页最后一条评论id,第一页默认0
 * @property `[orderBy]` 排序方式, 0正序-最早优先 1倒序-最新优先
 * @property `pageSize` 每页条数
 */
export interface ParamscommentsAnswerAnwserIdCommentsByIdUsingGet {
  // pathParams
  /**
   * 回答id
   */
  answerId: number;
  // queryParams
  /**
   * 上一页最后一条评论id,第一页默认0
   */
  lastCommentId: number;
  /**
   * 排序方式, 0正序-最早优先 1倒序-最新优先
   */
  orderBy?: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description commentsArticleArticleBusinessIdCommentsByBusinessIdUsingGet参数
 * @property `articleId` 文章id
 * @property `lastCommentId` 上一页最后一条评论id,第一页默认0
 * @property `[orderBy]` 排序方式, 0正序-最早优先 1倒序-最新优先
 * @property `pageSize` 每页条数
 */
export interface ParamscommentsArticleArticleBusinessIdCommentsByBusinessIdUsingGet {
  // pathParams
  /**
   * 文章id
   */
  articleId: string;
  // queryParams
  /**
   * 上一页最后一条评论id,第一页默认0
   */
  lastCommentId: number;
  /**
   * 排序方式, 0正序-最早优先 1倒序-最新优先
   */
  orderBy?: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description commentsArticleArticleBusinessIdCommentsNewUsingGet参数
 * @property `articleId` 文章id
 * @property `[orderBy]` 排序方式, 0正序-最早优先 1倒序-最新优先
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamscommentsArticleArticleBusinessIdCommentsNewUsingGet {
  // pathParams
  /**
   * 文章id
   */
  articleId: string;
  // queryParams
  /**
   * 排序方式, 0正序-最早优先 1倒序-最新优先
   */
  orderBy?: number;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description commentsArticleArticleIdCommentsByIdUsingGet参数
 * @property `articleId` 文章id
 * @property `lastCommentId` 上一页最后一条评论id,第一页默认0
 * @property `[orderBy]` 排序方式, 0正序-最早优先 1倒序-最新优先
 * @property `pageSize` 每页条数
 */
export interface ParamscommentsArticleArticleIdCommentsByIdUsingGet {
  // pathParams
  /**
   * 文章id
   */
  articleId: number;
  // queryParams
  /**
   * 上一页最后一条评论id,第一页默认0
   */
  lastCommentId: number;
  /**
   * 排序方式, 0正序-最早优先 1倒序-最新优先
   */
  orderBy?: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description commentsArticleArticleIdCommentsUsingGet参数
 * @property `articleId` 文章id
 * @property `[orderBy]` 排序方式, 0正序-最早优先 1倒序-最新优先
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamscommentsArticleArticleIdCommentsUsingGet {
  // pathParams
  /**
   * 文章id
   */
  articleId: number;
  // queryParams
  /**
   * 排序方式, 0正序-最早优先 1倒序-最新优先
   */
  orderBy?: number;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description commentsCommentIdUsingGet参数
 * @property `commentId` commentId
 */
export interface ParamscommentsCommentIdUsingGet {
  // pathParams
  /**
   * commentId
   */
  commentId: number;
}
/**
 * @description commentsCommentIdUsingPut参数
 * @property `commentId` 评论id
 * @property `comment` 评论内容
 */
export interface ParamscommentsCommentIdUsingPut {
  // pathParams
  /**
   * 评论id
   */
  commentId: number;
  // queryParams
  /**
   * 评论内容
   */
  comment: string;
}
/**
 * @description commentsIdUsingDelete参数
 * @property `id` 评论id
 */
export interface ParamscommentsIdUsingDelete {
  // pathParams
  /**
   * 评论id
   */
  id: number;
}
/**
 * @description commentsSubUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 * @property `respondCommentId` 所在评论id
 */
export interface ParamscommentsSubUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
  /**
   * 所在评论id
   */
  respondCommentId: number;
}
/**
 * @description commentsThumbUpIdUsingDelete参数
 * @property `id` 评论id
 */
export interface ParamscommentsThumbUpIdUsingDelete {
  // pathParams
  /**
   * 评论id
   */
  id: number;
}
/**
 * @description commentsThumbUpIdUsingPost参数
 * @property `id` 评论id
 */
export interface ParamscommentsThumbUpIdUsingPost {
  // pathParams
  /**
   * 评论id
   */
  id: number;
}
/**
 * @description commentsUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamscommentsUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * 评论内容
 */
export type ParamsBodycommentsUsingPost = models.CommentRequestParam;
export class CommentApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 根据当前问答id分页查询全部评论(通过id获取分页)
   * @param params ParamscommentsAnswerAnwserIdCommentsByIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultCommentInfo
   */
  public commentsAnswerAnwserIdCommentsByIdUsingGet = (
    params: ParamscommentsAnswerAnwserIdCommentsByIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultCommentInfo> => {
    const path = '/api/comments/answer/{anwserId}/commentsById';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('lastCommentId' in params) p.query.lastCommentId = params.lastCommentId;
    ajax.check(params.lastCommentId, 'lastCommentId');
    if ('orderBy' in params) p.query.orderBy = params.orderBy;
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.answerId, 'answerId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据当前文章分页查询全部评论(通过articleBusinessId获取分页)
   * @param params ParamscommentsArticleArticleBusinessIdCommentsByBusinessIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultCommentInfo
   */
  public commentsArticleArticleBusinessIdCommentsByBusinessIdUsingGet = (
    params: ParamscommentsArticleArticleBusinessIdCommentsByBusinessIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultCommentInfo> => {
    const path = '/api/comments/article/{articleBusinessId}/commentsByBusinessId';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('lastCommentId' in params) p.query.lastCommentId = params.lastCommentId;
    ajax.check(params.lastCommentId, 'lastCommentId');
    if ('orderBy' in params) p.query.orderBy = params.orderBy;
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据当前文章的articleBusinessid分页查询全部评论
   * @param params ParamscommentsArticleArticleBusinessIdCommentsNewUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListCommentInfo
   */
  public commentsArticleArticleBusinessIdCommentsNewUsingGet = (
    params: ParamscommentsArticleArticleBusinessIdCommentsNewUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListCommentInfo> => {
    const path = '/api/comments/article/{articleBusinessId}/comments-new';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('orderBy' in params) p.query.orderBy = params.orderBy;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据当前文章分页查询全部评论(通过id获取分页)
   * @param params ParamscommentsArticleArticleIdCommentsByIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultCommentInfo
   */
  public commentsArticleArticleIdCommentsByIdUsingGet = (
    params: ParamscommentsArticleArticleIdCommentsByIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultCommentInfo> => {
    const path = '/api/comments/article/{articleId}/commentsById';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('lastCommentId' in params) p.query.lastCommentId = params.lastCommentId;
    ajax.check(params.lastCommentId, 'lastCommentId');
    if ('orderBy' in params) p.query.orderBy = params.orderBy;
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据当前文章分页查询全部评论
   * @param params ParamscommentsArticleArticleIdCommentsUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListCommentInfo
   */
  public commentsArticleArticleIdCommentsUsingGet = (
    params: ParamscommentsArticleArticleIdCommentsUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListCommentInfo> => {
    const path = '/api/comments/article/{articleId}/comments';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('orderBy' in params) p.query.orderBy = params.orderBy;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看评论详情包括子评论)
   * @param params ParamscommentsCommentIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultCommentInfo
   */
  public commentsCommentIdUsingGet = (
    params: ParamscommentsCommentIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultCommentInfo> => {
    const path = '/api/comments/{commentId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.commentId, 'commentId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据id更新评论
   * @param params ParamscommentsCommentIdUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public commentsCommentIdUsingPut = (
    params: ParamscommentsCommentIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/comments/{commentId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('comment' in params) p.query.comment = params.comment;
    ajax.check(params.comment, 'comment');
    ajax.check(params.commentId, 'commentId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据id删除单个评论
   * @param params ParamscommentsIdUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public commentsIdUsingDelete = (
    params: ParamscommentsIdUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/comments/{id}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.id, 'id');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据评论id分页获取子评论
   * @param params ParamscommentsSubUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultCommentInfo
   */
  public commentsSubUsingGet = (
    params: ParamscommentsSubUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultCommentInfo> => {
    const path = '/api/comments/sub';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('respondCommentId' in params) p.query.respondCommentId = params.respondCommentId;
    ajax.check(params.respondCommentId, 'respondCommentId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 返回取消后的赞数
   * @summary 评论取消点赞
   * @param params ParamscommentsThumbUpIdUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResultint
   */
  public commentsThumbUpIdUsingDelete = (
    params: ParamscommentsThumbUpIdUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultint> => {
    const path = '/api/comments/thumb-up/{id}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.id, 'id');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 返回点赞后的赞数
   * @summary 评论点赞
   * @param params ParamscommentsThumbUpIdUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResultint
   */
  public commentsThumbUpIdUsingPost = (
    params: ParamscommentsThumbUpIdUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultint> => {
    const path = '/api/comments/thumb-up/{id}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.id, 'id');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据当前登录用户分页查询全部评论
   * @param params ParamscommentsUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultUserCommentInfo
   */
  public commentsUsingGet = (
    params: ParamscommentsUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultUserCommentInfo> => {
    const path = '/api/comments';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 新增评论
   
   * @param data: ParamsBodycommentsUsingPost// 评论内容
   * @param opt ajax config
   * @returns models.CommonResultCommentInfo
   */
  public commentsUsingPost = (
    data: ParamsBodycommentsUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultCommentInfo> => {
    const path = '/api/comments';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.comment');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new CommentApi();
